<template>
  <div style="float:right">
    <div class="ori-detail-quick">
      <div class="ori-structure-btn" @click="open">
        <div>
          <img :src="imgSrc" alt />
          <span>{{createText}}</span>
        </div>
      </div>
      <div class="ori-structure-box">
        <div class="ori-common-tit-h2">
          <b>项目概况简述</b>
        </div>
        <div class="ori-project-intro">
          <!-- <div class="pro-intro-row">入场时间：{{header.creatTime.split(' ')[0]}}</div> -->
          <div class="ori-pro-intro-row">项目地点：{{header.proAddr}}</div>
          <div class="ori-pro-intro-row">项目简介：</div>
          <div class="ori-pro-intro-txt">{{header.desc}}</div>
        </div>
        <div class="ori-common-tit-h2">
          <a @click="openxq" class="ori-more-tit-btn">项目详情&gt;</a>
        </div>
      </div>
      <div class="ori-structure-box">
        <div v-if="item.type == '项目经理'" v-for="(item,index) in header.projectPartner" :key="index">
          <div class="ori-com-md-face">
            <img :src="item.headImage" alt />
          </div>
          <div class="ori-str-row">
            <span class="ori-str-label">{{item.type}}</span>
            <i class="ori-star-icon"></i>
          </div>
          <div class="ori-str-row">
            <span class="ori-str-name">{{item.nickName}}</span>
            <span class="ori-str-tag-icon">{{item.tags.join(',')}}</span>
          </div>
        </div>
      </div>
      <div class="ori-structure-box" v-if="header.lsProject && header.lsProject.length>0">
        <div class="ori-common-tit-h2">
          <b>类似项目</b>
        </div>
        <div class="ori-guess-like">
          <router-link
            tag="a"
            v-for="(item,i) in header.lsProject"
            :key="i"
            :to="{name:'jxjDetail',params:{id:item.id}}"
            class="ori-guess-item"
          >
            <div class="ori-guess-face">
              <img :src="item.picPath" alt />
            </div>
            <div class="ori-guess-info">{{item.title}}</div>
          </router-link>
        </div>
      </div>
      <div class="ori-scan-code-quick">
        <div class="ori-code-quick-pic">
          <qrcode-vue :value="localHref" :size="170" level="H"></qrcode-vue>
        </div>
      </div>
    </div>
    <d-xiangqing :detail="header" @initBaiduMap="initBaiduMap" @close="closexq" v-if="xiangqingDir"></d-xiangqing>
  </div>
</template>

<script>
import '../../../../../html/pages/originality/modifyProject/modifyProject.scss';
import "../../../../../html/components/detailAside/detailAside.scss";

import { getJxjDetail, getWeather } from '../../../../../api/index.js';

import dXiangqing from '../../detail/components/d-xiangqing.vue';
import QrcodeVue from 'qrcode.vue';

import { mapState, mapMutations } from 'vuex';

export default {
  name: 'detailAside',
  components: {
    dXiangqing,
    QrcodeVue
  },
  data() {
    return {
      localHref: location.href,
      xiangqingDir: false,
      header: { now: '', picPath: '' },
      type: 'all',
      test:{
        first:'first',
        last:'last'
      }
    };
  },
  props: {
    createText: {
      type: String,
      required: true
    },
    imgSrc: {
      type: String,
      required: true
    },
    IsLogin: {
      type: Boolean
    },
    CanOperat: {
      type: Boolean
    }
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    initBaiduMap() {
      let opints = this.header.proPoint.split(',');
      let that = this;
      let script = document.createElement("script");
      script.src = "//api.map.baidu.com/api?v=2.0&ak=uVdH4iqsEd2BPnlCupOlHFUytU7eqiWL&callback=createMap"
      document.head.appendChild(script)
      window.createMap = () => {
        //创建Map实例
        var map = new BMap.Map("mapContent");
        var point = new BMap.Point(opints[0], opints[1]);
        map.centerAndZoom(point, 16);
        var marker = new BMap.Marker(point);        // 创建标注    
        map.addOverlay(marker);
        map.enableScrollWheelZoom();
      }
    },
    async getHeader() {
      let res = await getJxjDetail({
        id: this.$route.params.id
      });
      if (res.Type == 'Success') {
        // res.Data.timeAgo = timeago(new Date(res.Data.now));
        this.header = res.Data;
      }
    },
    closexq() {
      this.xiangqingDir = false;
    },
    openxq() {
      this.xiangqingDir = true;
    },
    open() {
      if (!this.IsLogin) {
        this.$layer.alert('您还未登录，请登录', (layerid) => {
          this.$layer.close(layerid);
          this.$login.show(1, userInfo => {
            this.setUserInfo(userInfo);
            this.$emit('init')
          });
        })
      } else if (!this.CanOperat) {
        this.$layer.alert('您没有权限创建');
      } else {
        this.$emit('open');
      }
    }
  },
  created() {
    this.getHeader();
  },
  watch: {
    $route(to, from) {
      this.type = 'all';
      this.getHeader();
    }
  },
};
</script>